<template>
  <div></div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
div {
  background-color: #cde000;
  height: 2px;
  position: relative;
  clear: both;

  &:before,
  &:after {
    content: "";
    display: block;
    height: 8px;
    width: 8px;
    border-radius: 8px;
    background-color: #cde000;
    position: absolute;
    top: -3px;
  }

  &:before {
    left: 0;
  }

  &:after {
    right: 0;
  }
}
</style>
